import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./style.css"; // Import the CSS file for styling

const faqs = [
	{
    	question: "What services does MedFirst ENT Centre offer?",
    	answer: "MedFirst ENT Centre provides comprehensive care for all Ear, Nose, Throat, Head &amp; Neck conditions under one roof. Our services include treatment for hearing loss, ear infections, tinnitus, sinusitis, nasal blockage, snoring, vertigo, voice disorders, tonsils, adenoids, allergy-related problems, and balance issues. We also offer advanced diagnostic facilities like hearing tests and endoscopic examinations, along with both medical and surgical management. Our goal is to deliver ethical, accurate, and patient-friendly ENT care using modern techniques.",
  	},
  	{
    	question: "Who is the doctor at MedFirst ENT Centre?",
    	answer: <>The clinic is led by <strong>Dr. (Major) Rajesh Bhardwaj</strong>, a highly experienced ENT Specialist known for ethical care, accurate diagnosis, and patient-friendly treatment.</>,
  	},
  	{
    	question: "Where is MedFirst ENT Centre located?",
    	answer: "We are located at: D-3/14, Ground Floor, Vasant Vihar, New Delhi – 110057",
  	},
  	{
    	question: "What are the clinic’s OPD timings?",
    	answer: "MedFirst ENT Centre operates by scheduled appointments. For exact timings and availability, patients are advised to call the clinic directly.",
  	},
	{
    	question: "Do I need an appointment before visiting?",
    	answer: "Yes, we recommend booking an appointment in advance to avoid waiting time and to ensure proper consultation.",
  	},
	{
    	question: "Are surgeries also done through MedFirst ENT Centre?",
    	answer: "Yes, MedFirst ENT Centre provides complete consultation, planning, and post-operative care for various ENT surgeries. These include procedures like septoplasty, FESS (sinus surgery), tonsillectomy, adenoidectomy, ear surgeries, snoring-related treatments, and voice procedures. Dr. (Major) Rajesh Bhardwaj carefully evaluates each case and recommends surgery only when truly required. Our focus is always on patient safety, minimal discomfort, and faster recovery using modern surgical techniques.",
  	},
	{
    	question: "Does MedFirst ENT Centre accept TPA / insurance for cashless treatment?",
    	answer: "Yes, MedFirst ENT Centre assists patients with TPA and insurance-related processes for eligible procedures and hospital-based treatments. We guide patients regarding documentation, approvals, and coordination with associated hospitals for cashless services. Our team helps make the insurance process smooth and transparent so patients can focus on recovery rather than paperwork. For exact details about panel hospitals and insurance partners, we recommend contacting the clinic directly.",
  	},
	{
    	question: "How can I book an appointment at MedFirst ENT Centre?",
    	answer: <>You can book an appointment by calling +91-9871150032, +91-9289861631 or visiting our website: <a href="https://entdelhi.com">entdelhi.com</a></>,
  	}
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
    <section className="faq py-5 my-5">
        <div className="container">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQ</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>

            <div className="col-xl-12 mt-xl-0 mt-5 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {faqs.map((faq, index) => (
                  <div
                    className={`pq-accordion-box ${
                      activeIndex === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    <div
                      className="pq-ad-title"
                      onClick={() => toggleAccordion(index)}
                    >
                      <h4 className="ad-title-text">
                        {faq.question}
                        <i
                          className={`fa ${
                            activeIndex === index
                              ? "fa-chevron-up"
                              : "fa-chevron-down"
                          }`}
                        ></i>
                      </h4>
                    </div>
                    <div
                      className={`pq-accordion-details ${
                        activeIndex === index ? "open" : ""
                      }`}
                    >
                      <p className="pq-detail-text">{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;